export const INITIALIZE_FILTERING = 'INITIALIZE_FILTERING';
export const INITIALIZE_FILTERING_SUCCESS = `${INITIALIZE_FILTERING}/SUCCESS`;
export const INITIALIZE_FILTERING_FAILURE = `${INITIALIZE_FILTERING}/FAILURE`;

export const GET_AUTO_COMPLETE_SUGGESTIONS = 'GET_AUTO_COMPLETE_SUGGESTIONS';
export const GET_AUTO_COMPLETE_SUGGESTIONS_SUCCESS = `${GET_AUTO_COMPLETE_SUGGESTIONS}/SUCCESS`;
export const GET_AUTO_COMPLETE_SUGGESTIONS_FAILURE = `${GET_AUTO_COMPLETE_SUGGESTIONS}/FAILURE`;

export const APPLY_FILTERS_V2 = 'APPLY_FILTERS_V2';
export const APPLY_FILTERS_SUCCESS_V2 = `${APPLY_FILTERS_V2}/SUCCESS`;
export const APPLY_FILTERS_FAILURE_V2 = `${APPLY_FILTERS_V2}/FAILURE`;

export default {
  INITIALIZE_FILTERING,
  INITIALIZE_FILTERING_SUCCESS,
  INITIALIZE_FILTERING_FAILURE,

  GET_AUTO_COMPLETE_SUGGESTIONS,
  GET_AUTO_COMPLETE_SUGGESTIONS_SUCCESS,
  GET_AUTO_COMPLETE_SUGGESTIONS_FAILURE,

  APPLY_FILTERS_V2,
  APPLY_FILTERS_SUCCESS_V2,
  APPLY_FILTERS_FAILURE_V2
};
